
export const getHomepage = (): string => {
    return process.env.REACT_APP_BASENAME || '/';
};

export const getBasename = (): string => {
    return process.env.REACT_APP_BASENAME || '/';
};